module.exports = __webpack_public_path__ + "static/SFMono-Semibold-cebe2bfbe8a283427e3c5ad8a1b8ae2f.woff2";